module.exports = __webpack_public_path__ + "static/media/img-layout.37e7a115.png";